import axios from "axios";
import store from "./store";

let baseURL = window.API_BASE_URL;
let axiosApi = axios.create({ baseURL });
let axiosApiAnonymous = axios.create({ baseURL });
let axiosApiApp = axios.create({ baseURL });

export let setAuthHeader = (token) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};
export let setAuthHeaderApp = (token) => {
  axiosApiApp.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export default axiosApi;

export class APIService {
  lojaUrlSlug = null;

  constructor() {}

  getUrl(urlBase) {
    baseURL = urlBase;
    axiosApi = axios.create({ baseURL });
    axiosApiAnonymous = axios.create({ baseURL });
    axiosApiApp = axios.create({ baseURL });

    axiosApiApp.defaults.headers.common["Content-Type"] = "application/json";

    setAuthHeaderApp(sessionStorage.getItem("token"));
    setAuthHeader(sessionStorage.getItem("token"));
  }

  getCep(cep) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/microapp/app/util/consulta-cep/${cep}`;
    return axiosApi.get(url).then((response) => response.data);
  }
  getStore1(urlSlug) {
    this.getUrl(window.API_BASE_URL);
    this.lojaUrlSlug = urlSlug;
    const url = `/v3/wapp/marketplace/listar-produtos/${this.lojaUrlSlug}`;
    return axiosApiAnonymous.get(url).then((response) => {
      const token = response.headers.authorization.replace("Bearer ", "");
      setAuthHeader(token);
      return response.data;
    });
  }
  getStore(urlSlug, lojaId, categoriaId) {
    this.getUrl(window.API_BASE_URL);
    this.lojaUrlSlug = urlSlug;
    const filters =
      lojaId || categoriaId
        ? `?${lojaId ? `lojaId=${lojaId}` : ""}${
            categoriaId ? `&categoriaId=${categoriaId}` : ""
          }`
        : "";
    const url = `/v3/wapp/marketplace/listar-produtos/${this.lojaUrlSlug}${filters}`;

    return axiosApiAnonymous.get(url).then((response) => {
      return response.data;
    });
  }
  getProdutosFiltroTexto(urlSlug, lojaId, filtroTexto) {
    this.getUrl(window.API_BASE_URL);
    this.lojaUrlSlug = urlSlug;
    const filters =
      lojaId || filtroTexto
        ? `?${lojaId ? `lojaId=${lojaId}` : ""}${
            filtroTexto ? `&pesquisaProduto=${filtroTexto}` : ""
          }`
        : "";
    const url = `/v3/wapp/marketplace/listar-produtos/${this.lojaUrlSlug}/filtro${filters}`;

    return axiosApiAnonymous.get(url).then((response) => {
      return response.data;
    });
  }

  obterConfig(hostnameUrl) {
    this.getUrl(window.API_BASE_URL);
    const url = "config/" + hostnameUrl + "_config.json";
    return axios
      .create()
      .get(url)
      .then((response) => response.data);
  }

  obterListaOcupacao() {
    const url = "config/ocupacao.json";
    return axios
      .create()
      .get(url)
      .then((response) => response.data);
  }

  obterPagina(pagina) {
    this.getUrl(window.API_BASE_URL);
    const url = `paginas/${window.APP_ORIGIN}/${pagina}.html`;
    return axios
      .create()
      .get(url)
      .then((response) => response.data);
  }

  obterCategoria() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/marketplace/categorias/${window.URL_SLUG}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }
  getProduct(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/wapp/marketplace/loja/${window.URL_SLUG}/produto/${id}`;
    return axiosApi.get(url).then((response) => response.data);
  }
  cadastrarPedido(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = "/v1/marketplace-pedidos/cadastrar";
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  cadastrarPedidoByToken(obj, token) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/marketplace-pedidos/cadastrar/${token}`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  obterPedido(codigoPedido) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/microapp/app/delivery/pedido/${codigoPedido}`;
    return axiosApi.get(url).then((response) => response.data);
  }
  salvarEndereco(enderecoForm) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/conta/atualizar-endereco`;
    return axiosApiApp
      .post(url, enderecoForm)
      .then((response) => response.data);
  }
  salvarEntrega(enderecoForm, idCarrinho) {
    this.getUrl(window.API_BASE_URL);
    const url = `v1/marketplace-pedidos/cadastrar-endereco-entrega/${idCarrinho}`;
    return axiosApiApp
      .post(url, enderecoForm)
      .then((response) => response.data);
  }
  cancelarPedido(idPedido, estorno) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/estorno/${idPedido}/estornar-pedido`;
    return axiosApiApp.post(url, estorno).then((response) => response.data);
  }

  ativarPlanoAssociado(contaId, planoId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/plano/servicos/ativar/${contaId}/${planoId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  getIndicacoesPendentes() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v3/rede-indicacao/situacao?situacao=PENDENTE_CADASTRADO`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  getcodigoCupom() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v3/cupom/indicacao`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  aplicarCupomDesconto(pedidoId, cupomDesconto) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/carrinho/aplicar-cupom/${pedidoId}/cupom/${cupomDesconto}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }  
  
  removerCupomDesconto(pedidoId, id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/carrinho/aplicar-cupom/${pedidoId}/cupom/${id}/remover`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  iniciarPlanoAssociado(idPlano, dadosConta) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/assinar-plano/${idPlano}`;
    return axiosApiApp.post(url, dadosConta).then((response) => response.data);
  }
  checkout(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = "/v2/microapp/app/delivery/pedido/cadastrar-e-checkout";
    return axiosApi.post(url, obj).then((response) => response.data);
  }
  verificaPagamento(codigoPedido, codigoPagamento) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/microapp/app/delivery/pedido/${codigoPedido}/pagamento/${codigoPagamento}/status`;
    return axiosApi.get(url).then((response) => response.data);
  }
  obterListaAssinaturas() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/anon/listar/${window.APP_ORIGIN}`;
    return axiosApi.get(url).then((response) => response.data);
  }
  obterAssinatura(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/anon/${id}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }
  obterDadosPlano(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/anon/${id}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }

  obterPlanoSimulacao(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/simulacao/plano-assinatura/${id}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }

  contratarPlano(plano) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/simulacao/plano-assinatura/contratar`;
    return axiosApiApp.post(url, plano).then((response) => response.data);
  }

  assinarPlano(id, idModeloPagamento) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/assinar-plano/${id}/${idModeloPagamento}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  gerarPagamento(idPlano, idModeloPagamento) {
    this.getUrl(window.API_BASE_URL);
    const url = `v2/simulacao/plano-assinatura/${idPlano}/${idModeloPagamento}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  obterAgendamentos() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/plano/servicos/obter-agendamentos`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterPlanoCliente(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/plano/servicos/${id}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  obterMinhasAssinaturas() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/planos/listar/minhas-assinaturas`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  obterMinhasParcelas(recorrenciaId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/recorrencia/pacelas/${recorrenciaId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterMinhasRecorrencias() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/planos/listar/recorrencia-em-andamento`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterParcela(recorrenciaId, pagamentoId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/recorrencia/pagamento-parcela/${recorrenciaId}/${pagamentoId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  obterMinhaAssinaturaID(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/recorrencia/detalhe-pagamento-recorrente/${id}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  obterServicosPlanoCliente(contaId, planoid) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/plano/servicos/${contaId}/${planoid}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  cancelarMinhaAssinatura(codigo) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/cancelar-plano-assinatura/${codigo}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  pedidoAcompanhar(idPedido) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/wapp/marketplace/pedido/listar-historico/${idPedido}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }
  verificarContaExistente(cpfCnpj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/usuario/verificar-conta-existente/${
      window.APP_ORIGIN
    }/${cpfCnpj
      .replace(".", "")
      .replace(".", "")
      .replace("-", "")
      .replace("/", "")}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }
  verificarContaExistenteSportheca(email) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/usuario/verificar-conta-existente/${window.APP_ORIGIN}/${email}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }

  loginAccessToken(accessToken) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v3/integracao/authenticate/app/${accessToken}`;
    return axiosApiApp
      .get(url)
      .then((response) => this.obterDadosUsuario(response.data.id_token));
  }

  login(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/account/authenticate/app/${window.APP_ORIGIN}`;
    return axiosApiApp
      .post(url, obj)
      .then((response) => this.obterDadosUsuario(response.data.id_token));
  }
  loginSportheca(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `v1/account/authenticate/sportheca/sso/${window.APP_ORIGIN}`;
    return axiosApiApp
      .post(url, obj)
      .then((response) => this.obterDadosUsuario(response.data.id_token));
  }
  
  loginBearerTokenSportheca(bearerToken) {
    this.getUrl(window.API_BASE_URL);

    const headers = {
      'Content-Type': 'application/json',
      'bearerTokenOneFan': bearerToken
    }

    const url = `/v2/account/authenticate/sportheca/sso/${window.APP_ORIGIN}/token`;
    return axiosApiApp
      .post(url, null, { headers })
      .then((response) => this.obterDadosUsuario(response.data.id_token));
  }
  
  obterDadosUsuario(token) {
    this.getUrl(window.API_BASE_URL);
    this.getUrl(window.API_BASE_URL);
    sessionStorage.setItem("token", token);
    localStorage.setItem("token", token);
    setAuthHeaderApp(token);
    return this.dadosApp();
  }
  dadosApp() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v3/conta/dadosSemFoto`;
    return axiosApiApp
      .get(url)
      .then((response) => {
        sessionStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("accessToken", response.data.accessToken);
        return response.data;
      })
      .catch(
        (error) =>
          error.response.data.detail === "Access is denied" &&
          store.dispatch("loginApp", null)
      );
  }
  register(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/conta/cadastrar/${window.APP_ORIGIN}`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  registerSportheca(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/conta/cadastrar/sportheca/${window.APP_ORIGIN}`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  validarCodigo(obj, objLogin) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/cadastro/pessoa-fisica/${window.APP_ORIGIN}/${objLogin.usuario}/validar-codigo`;
    return axiosApiApp.post(url, obj).then(() => this.login(objLogin));
  }
  atualizarUsuario(cpf, obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/cadastro/pessoa-fisica/${window.APP_ORIGIN}/${cpf}`;
    return axiosApiApp.put(url, obj).then((response) => response.data);
  }

  atualizarConta(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/conta/cadastro/atualizar`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }

  resetpasswordinit(params) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/account/reset-password/init/app/${window.APP_ORIGIN}`;
    return axiosApiApp.post(url, params).then((response) => response.data);
  }
  resetpasswordinitSportheca(params) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/account/reset-password/init/app/sportheca/${window.APP_ORIGIN}`;
    return axiosApiApp.post(url, params).then((response) => response.data);
  }
  resetpasswordconfirmcode(code) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/account/reset-password/confirm-code/app/${code}/${window.APP_ORIGIN}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  pesquisarDescontos(categoria, uf, search) {
    this.getUrl(window.API_BASE_URL);
    categoria = categoria === undefined ? '' : categoria;
    
    const url = `/v2/plano/servicos/clube-desconto/listar/${window.APP_ORIGIN}?categoria=${categoria}&uf=${uf}&search=${search}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  obterClubeBeneficio(idLoja, accessToken) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/plano/servicos/clube-desconto/listar/${window.APP_ORIGIN}/${idLoja}/${accessToken}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  atualizarDadosClubeBeneficio(obj, lojaId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/plano/servicos/clube-desconto/ativar-assinatura/${lojaId}`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  obeterCatgoriaDescontos() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/plano/servicos/clube-desconto/categorias/listar/${window.APP_ORIGIN}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  resetpasswordchange(codigo, params) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/account/reset-password/confirm-code/${codigo}/${window.APP_ORIGIN}`;
    return axiosApiApp.post(url, params).then((response) => response.data);
  }
  alterarSenhaUsuarrio(obj) {
    this.getUrl(window.API_BASE_URL);
    console.log('log', obj);
    const url = `v2/backoffice/usuarios/alterar-senha`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  getListarPedidos() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/microapp/marketplace/pedido/listar-pedidos/${window.URL_SLUG}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  getPedidoID(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/wapp/marketplace/pedido/obter-pedido/${id}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }  
  getPedidoPendente() {
    this.getUrl(window.API_BASE_URL);
    const url = `v2/wapp/marketplace/pedido/obter-pedido-pendente/${window.URL_SLUG}`;
    // let accessToken = localStorage.getItem("accessToken");
    return axiosApiApp.get(url).then((response) => response.data);
  }  
  getPedidoPendenteByToken(token) {
    this.getUrl(window.API_BASE_URL);
    const url = `v2/wapp/marketplace/pedido/obter-pedido-pendente/${window.URL_SLUG}/${token}`;
    // let accessToken = localStorage.getItem("accessToken");
    return axiosApiApp.get(url).then((response) => response.data);
  }  
  atualizarItensCarrinho(pedido) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/marketplace-pedido-items/atualizar`;
    return axiosApiApp.post(url, pedido).then((response) => response.data);
  }  
  atualizarItensCarrinhoByToken(pedido, token) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/marketplace-pedido-items/atualizar/item/${token}`;
    return axiosApiApp.post(url, pedido).then((response) => response.data);
  }
  obterFrete(cep, obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/calcular/${cep}?idPedido=${obj.id}`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  itemAdicionar(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/marketplace-pedido-items/item-adicionar`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  } 

  adicionarItensCarrinho(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/marketplace-pedido-items/item-adicionar`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }

  getCarteira() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/carteira`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  cadastrarCartaoSemForm(cartaoToken) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/cartao/cadastrar`;
    return axiosApiApp.post(url, cartaoToken).then((response) => response.data);
  }

  getListaCartoes() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/conta/cartao/listar`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  getCartao(codigoCartao) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/cartao/${codigoCartao}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  getFuncionalidade(codigoRede) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/funcionalidade/rede/${codigoRede}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  getFuncionalidadeV2(codigoRede) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/funcionalidade/rede/${codigoRede}`;
    return axiosApiAnonymous.get(url).then((response) => response.data);
  }

  getFuncionalidadeByCodigo(codigoRede, funcionalidade) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/funcionalidade/${codigoRede}/${funcionalidade}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  
  cadastrarCartao(cartaoToken) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/cartao/cadastrar`;
    return axiosApiApp.post(url, cartaoToken).then((response) => response.data);
  }

  reenviarCodigoAtivacao(cpf) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/cadastro/pessoa-fisica/${window.APP_ORIGIN}/${cpf}/reenviar-codigo`;
    return axiosApiApp.post(url, null).then((response) => response.data);
  }

  removerCartao(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/cartao/remover/${id}`;
    return axiosApiApp.post(url, id).then((response) => response.data);
  }
  pagarParcela(pagamento) {
    this.getUrl(window.API_BASE_URL);
    pagamento.metodo = "SALDO_CARTEIRA_CASHBACK";
    const url = `/v2/pagamento/realizar-pagamento-parcela`;
    return axiosApiApp.post(url, pagamento).then((response) => response.data);
  }

  cartaoConta(codigoCartao) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v3/conta/cartao/${codigoCartao}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  selecionaMeioPagamento(id, item) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/microapp/recorrencia/cartao/definir/${id}`;
    return axiosApiApp.post(url, item).then((response) => response.data);
  }
  cancelarAssinatura(codigoRecorrencia) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/cancelar-plano-assinatura/${codigoRecorrencia}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  excluirAssociado(idPagamento, id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/excluir-associado/${idPagamento}/${id}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  incluirAssociado(codigoRecorrencia, qualificacaoPessoa) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/incluir-associado/${codigoRecorrencia}`;
    return axiosApiApp
      .post(url, qualificacaoPessoa)
      .then((response) => response.data);
  }
  aceitarPagamento(detail) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/recorrencia/iniciar/${detail.codigoRecorrencia}`;
    return axiosApiApp.post(url, detail).then((response) => response.data);
  }
  obterDetalhePagamentoRecorrente(id) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/recorrencia/detalhe-pagamento-recorrente/${id}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  checkoutPagamento(idCarrinho, obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/microapp/marketplace/pedido/${idCarrinho}/checkout`;
    return axiosApiApp.post(url, obj).then((response) => response.data);
  }
  encerrarConta(motivo) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/conta/encerrar-conta`;
    return axiosApiApp.post(url, motivo).then((response) => response.data);
  }

  parcelamentoPermitido(codigoLoja) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/funcionalidade/loja/${codigoLoja}/PAGAMENTO_COMPRA_CARTAOCREDITO_QTD_MAX_PARCELA`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  cancelPayment(idCarrinho) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/marketplace-pedidos/${idCarrinho}/cancelar`;
    return axiosApiApp.post(url, null).then((response) => response.data);
  }

  enviarContato(obj) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/contato/leads/${window.APP_ORIGIN}`;
    return axiosApiAnonymous.post(url, obj).then((response) => response.data);
  }
  recalcularCompra(qtdParcelas, pedido) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/calcular-compra/${qtdParcelas}`;
    return axiosApiAnonymous
      .post(url, pedido)
      .then((response) => response.data);
  }

  simularParcelamentoCompra(pedido) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/simular-parcelamento-compra`;
    return axiosApiAnonymous
      .post(url, pedido)
      .then((response) => response.data);
  }

  obterInfoRedirectServico(idServico, idSala) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/plano/servicos/obter-info-redirect/${idServico}/${idSala}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterModeloCobranca(id, idModeloPagamento) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/planos/assinar-plano/${id}/${idModeloPagamento}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterBoletoPagamentoRecorrente(contaPagamentoRecorrenteId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/recupera-boleto-by-contapagamentorecorrente/${contaPagamentoRecorrenteId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterPagamentoBoleto(pagamentoId) {
    this.getUrl(window.API_BASE_URL);
    const url = `v1/recupera-boleto-by-contaregistropagamento/${pagamentoId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterPagamentoPix(pagamentoId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/conta-registro-cobrancas/${pagamentoId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterBoletoByPedido(pedidoId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/pedido/boleto/${pedidoId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  criarBoletoParaPedido(pagamento, pedidoId) {
    this.getUrl(window.API_BASE_URL);
    setAuthHeaderApp(sessionStorage.getItem("token"));

    const url = `/v1/boleto/marketplace/${pedidoId}/cadastrar`;
    return axiosApiApp.post(url, pagamento).then((response) => response.data);
  }

  excluirItemPedido(itemId, quantidade, pedidoDTO) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/remover-item/${itemId}/${quantidade}`;
    return axiosApiAnonymous
      .post(url, pedidoDTO)
      .then((response) => response.data);
  }


  excluirPedido(itensId, pedidoDTO) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/remover-itens/${itensId}`;
    return axiosApiAnonymous
      .post(url, pedidoDTO)
      .then((response) => response.data);
  }
  

  adicionarItemPedido(itemId, pedidoDTO) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/adicionar-item/${itemId}`;
    return axiosApiAnonymous
      .post(url, pedidoDTO)
      .then((response) => response.data);
  }  
  
  adicionarItemPedidoQuantidade(itemId, pedidoDTO, quantidade) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/adicionar-item/${itemId}/${quantidade}`;
    return axiosApiAnonymous
      .post(url, pedidoDTO)
      .then((response) => response.data);
  }

  alterarOpcaoFrete(itemId, freteId, pedidoDTO) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/marketplace/pedido/alterar-opcao-frete/${itemId}/${freteId}`;
    return axiosApiAnonymous
      .post(url, pedidoDTO)
      .then((response) => response.data);
  }

  obterCobrancaPixPorPedido(pedidoId, status) {
    this.getUrl(window.API_BASE_URL);
    setAuthHeaderApp(sessionStorage.getItem("token"));
    const params = { params: { status: status } }

    const url = `/v1/conta-registro-cobrancas/pedido/${pedidoId}`;
    
    if(status) {
      return axiosApiApp.get(url, { params: params })
      .then((response) => response.data);
    } else {
      return axiosApiApp.get(url).then((response) => response.data);
    }
  }

  criarCobrancaPixParaPedido(pagamento, pedidoId) {
    this.getUrl(window.API_BASE_URL);
    setAuthHeaderApp(sessionStorage.getItem("token"));

    const url = `/v1/conta-registro-cobrancas/pedido/${pedidoId}/cadastrar`;
    return axiosApiApp.post(url, pagamento).then((response) => response.data);
  }

  obterPixPagamentoRecorrente(contaPagamentoRecorrenteId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/conta-registro-cobrancas/pagamento-recorrente/${contaPagamentoRecorrenteId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterCobrancaPixPorId(contaRegistroCobrancaId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/conta-registro-cobrancas/${contaRegistroCobrancaId}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  verificaParcelaPagamento(recorrenciaId, pagamentoId) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/recorrencia/pacelas/${recorrenciaId}/${pagamentoId}/check`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  pagarParcelaPix(pagamento) {
    this.getUrl(window.API_BASE_URL);
    pagamento.metodo = "PIX";
    const url = `/v2/pagamento/realizar-pagamento-parcela/pix`;
    return axiosApiApp.post(url, pagamento).then((response) => response.data);
  }

  obterCategorias() {
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/plano-assinatura/categorias`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  validarCPF(val) {
    var cpf = val.trim();
    cpf = cpf.replace(/\./g, "");
    cpf = cpf.replace("-", "");
    cpf = cpf.split("");
    var v1 = 0;
    var v2 = 0;
    var aux = false;
    for (var i = 1; cpf.length > i; i++) {
      if (cpf[i - 1] != cpf[i]) {
        aux = true;
      }
    }
    if (aux == false) {
      return false;
    }
    for (var i1 = 0, p = 10; cpf.length - 2 > i1; i1++, p--) {
      v1 += cpf[i1] * p;
    }
    v1 = (v1 * 10) % 11;
    if (v1 == 10) {
      v1 = 0;
    }
    if (v1 != cpf[9]) {
      return false;
    }
    for (var i2 = 0, p2 = 11; cpf.length - 1 > i2; i2++, p2--) {
      v2 += cpf[i2] * p2;
    }
    v2 = (v2 * 10) % 11;
    if (v2 == 10) {
      v2 = 0;
    }
    if (v2 != cpf[10]) {
      return false;
    } else {
      return true;
    }
  }

  validarCnpj(val) {
    var cnpj = val.trim();

    cnpj = cnpj.replace(/\./g, "");
    cnpj = cnpj.replace("-", "");
    cnpj = cnpj.replace("/", "");
    cnpj = cnpj.split("");

    var v1 = 0;
    var v2 = 0;
    var aux = false;
    for (var i = 1; cnpj.length > i; i++) {
      if (cnpj[i - 1] != cnpj[i]) {
        aux = true;
      }
    }
    if (aux == false) {
      return false;
    }
    for (var i1 = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i1; i1++, p1--, p2--) {
      if (p1 >= 2) {
        v1 += cnpj[i1] * p1;
      } else {
        v1 += cnpj[i1] * p2;
      }
    }
    v1 = v1 % 11;
    if (v1 < 2) {
      v1 = 0;
    } else {
      v1 = 11 - v1;
    }
    if (v1 != cnpj[12]) {
      return false;
    }
    for (
      var i2 = 0, p12 = 6, p22 = 14;
      cnpj.length - 1 > i2;
      i2++, p12--, p22--
    ) {
      if (p12 >= 2) {
        v2 += cnpj[i2] * p12;
      } else {
        v2 += cnpj[i2] * p22;
      }
    }
    v2 = v2 % 11;
    if (v2 < 2) {
      v2 = 0;
    } else {
      v2 = 11 - v2;
    }
    if (v2 != cnpj[13]) {
      return false;
    } else {
      return true;
    }
  }
  validaCpfCnpj(val) {
    if (val.length <= 14) {
      return true
      // this.validarCPF(val);
    } else if (val.length > 14 && val.length <= 18) {
      return this.validarCnpj(val);
    } else {
      return false;
    }
  } 
}
